import type { PivotField } from '@ztechapps/common.contract'
import { PivotAggregationEnum, PivotFieldTypeEnum } from '@ztechapps/common.contract'
import { listPivotFieldAggregations } from '@ztechapps/common.utils'
import { PIVOT_AGGREGATION_LABELS } from './constants'

/** The aggregation a field takes when first added to Values — Sum for a number field, Count otherwise. */
export const toPivotDefaultAggregation = (field?: PivotField): PivotAggregationEnum =>
  field?.type === PivotFieldTypeEnum.Number ? PivotAggregationEnum.Sum : PivotAggregationEnum.Count

/** The aggregations a field offers — every one for a number field, only the count kinds otherwise. */
export const listPivotAggregationOptions = (field?: PivotField): { value: PivotAggregationEnum; label: string }[] =>
  listPivotFieldAggregations(field?.type ?? PivotFieldTypeEnum.String).map((aggregation) => ({
    value: aggregation,
    label: PIVOT_AGGREGATION_LABELS[aggregation],
  }))
